import { useEffect, useState } from "react";
import ConfigProps from "../constants/configProps";
import ConfigPropService from "../utilities/configPropService";
import EnvironmentService from "../utilities/environmentService";

function useAddToList() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    ConfigPropService.get([
      ConfigProps.EnableResponsiveSearchResults,
    ]).subscribe((configProps) => {
      setEnabled(
        ConfigPropService.isYesOrTrue(
          configProps[ConfigProps.EnableResponsiveSearchResults],
        ) && !EnvironmentService.get().isEcom,
      );
    });
  }, []);

  return enabled;
}

export default useAddToList;
